module.exports = __webpack_public_path__ + "media/svgs/text-lets-work-3d37f1351b125f86a6a7901934b14fce.svg";